import React from 'react'
import { Price, PriceInfoContainer, PriceLabel, ProductCard } from 'chemistry'
import { Box, Text } from '@chakra-ui/react'

export const Card = ({ product, name, showPriceLabel, labelText, percentage, priceProps }) => {
  return (
    <ProductCard sizes={['sm']}>
      <ProductCard.Image>
        <Box position='relative'>
          <Box>
            <img src={product.poster.thumbUrl} alt={product.poster.alt} />
          </Box>
        </Box>
      </ProductCard.Image>

      <ProductCard.Title>
        <Text fontSize='sm' fontFamily='bold'>
          {name}
        </Text>
      </ProductCard.Title>

      <ProductCard.Price>
        <PriceInfoContainer>
          <PriceInfoContainer.Before>
            {showPriceLabel && <PriceLabel text={labelText} percentage={percentage} />}
          </PriceInfoContainer.Before>
          <PriceInfoContainer.Main>
            <Price {...priceProps} />
          </PriceInfoContainer.Main>
        </PriceInfoContainer>
      </ProductCard.Price>
    </ProductCard>
  )
}
